export default {
  name: 'experiment',
  type: 'object',
  fields: [
    {
      name: 'title',
      title: 'Title',
      type: 'string',
    },
    {
      name: 'slug',
      title: 'Slug',
      type: 'slug',
      options: {
        source: (doc, {parent}) => parent && parent.title,
      },
    },
  ],
}
